export const isNotFoundOrForbiddenError = (apiError: any) => {
    if (apiError && [403, 404].includes(apiError.status)) return true;

    return false;
};
